export default {
  app: {
    width: 800,
    verticalCount: 5,
    horizontalCount: 4,
    keyboardEnable: false,
    advancedSearchEnable: false,
    advancedSearchVisible: true,
    advancedSearchValuesFromNavbar: {},
    assetType: null
  },
  intl: {
    defaultLocale: "es",
    locale: "es",
    messages: []
  },
  authUser: {
    user: null,
    token: null,
    error: null
  },
  user: {
    passRecovered: false,
    changePasswordIsFetching: false,
    changePassword: "",
    changeAvatarIsFetching: false,
    isFetching: null,
    avatar: null,
    color: "",
    clientRole: ""
  },
  clients: {
    listTypeClient: [],
    listTypeBusinessClient: [],
    isFetching: true
  },
  client: {
    breadcrumb: null,
    breadcrumbAll: [], // utilizado para CRUD groups
    rootFolders: [],   // lazy loading en grupos
    rootFolderNavbar: [],
    data: {
      acountSetting: {
        logo: null
      },
      _id: null,
      root: null,
      media: [],
      statusAsset: null
    },
    isDone: null,
    workclient: null,
    isFetching: null,
    isFetchingAll: false, // utilizado para CRUD groups
    inFolderAction: false,
    isUploading: null,
    pidValue: null,
    downloadProgress: 0,
    headers: null,
    error: null,
    qtyFilesError: 0,
    attemps: [],
    numberAttemps: 0,
    isTourOpen: true,
    isFetchingSauronReport: false,
    uploadVersionAsset: {
      isShowingVersionAsset: false,
      isUploadingVersion: false,

      itemSelected: {
        document: null,
        userCreator: null,
        versions: []
      },
      breadCrumbs: null,
      keyCollection: null,
      from: null,
      files: [],
      versionTags: [],
      tags: [],
      usersOption: [],
      mentionedUsers: []
    }
  },
  searcher: {
    folderselect: null,
    isFetching: false,
    isUpdating: false,
    data: [],
    headers: [],
    error: null,
    activeView: "vertical",
    page: 1,
    limit: 20,
    editAssetTab: null,
    orderBy: "-createdAt",
    isAdvancedSearchActive: false, // INDICA SI EL BUSCADOR AVANZADO ESTÁ EN BÚSQUEDA ACTIVA, PARA PAGINACIÓN
    isAdvancedSearching: false, // INDICA SI ESTA REALIZANDO LA PETICION A API
    advancedSearchValues: "", // VALORES DE LA ÚLTIMA BÚSQUEDA
    showScrolling: false,
    pageScrolling: 1,
    isLoadingScroll: false,
    suggestions: [],
    loadingSuggest: false
  },
  assetsShared: {
    folderselect: null,
    isFetching: false,
    isUpdating: false,
    data: [],
    headers: [],
    error: null,
    sended: false,
    sharing: false,
    editAssetTab: null,
    activeView: "horizontal",
    page: 1,
    limit: 20
  },
  assetsFavorites: {
    folderselect: null,
    isFetching: false,
    isUpdating: false,
    data: [],
    headers: [],
    error: null,
    editAssetTab: null,
    activeView: "horizontal",
    page: 1
  },
  assetsLastUploads: {
    folderselect: null,
    isFetching: false,
    isUpdating: false,
    data: [],
    headers: [],
    error: null,
    activeView: "horizontal",
    page: 1,
    editAssetTab: null
  },
  assetsRoot: {
    folderselect: null,
    isFetching: false,
    isUpdating: false,
    activateMultiOptions: false,
    data: [],
    dataBack: [],
    headers: [],
    error: null,
    activeView: "vertical",
    page: 1,
    editAssetTab: null,
    showScrolling: false,
    pageScrolling: 1,
    isLoadingScroll: false
  },
  assetsExplore: {
    folderselect: null,
    isFetching: false,
    isUpdating: false,
    data: [],
    headers: [],
    error: null,
    activeView: "vertical",
    page: 1,
    limit: 20,
    editAssetTab: null,
    orderBy: "-createdAt",
    showScrolling: false,
    pageScrolling: 1,
    isLoadingScroll: false
  },
  assetsRootUpload: {
    folderselect: null,
    isFetching: false,
    isUpdating: false,
    activateMultiOptions: false,
    data: [],
    headers: [],
    error: null,
    activeView: "vertical",
    page: 1,
    editAssetTab: null
  },
  assetsExploreUpload: {
    folderselect: null,
    isFetching: false,
    isUpdating: false,
    data: [],
    dataBack: [],
    headers: [],
    error: null,
    activeView: "vertical",
    page: 1,
    limit: 20,
    editAssetTab: null,
    orderBy: "-createdAt"
  },
  assetsConfirm: {
    isFetching: false,
    data: [],
    headers: [],
    error: null,
    page: 1,
    status: "",
    confirmAssetsBy: "mine"
  },
  assetsPublicShared: {
    folderselect: null,
    isFetching: false,
    data: [],
    headers: [],
    error: null,
    page: 1,
    nameSharedAsset: "Compartido",
    activeView: "vertical",
    sharedBreadCrumb: [],
    assetHasPassword: null,
    wrongPassword: null
  },
  bitacora: {
    isFetching: false,
    data: [],
    headers: [],
    error: null
  },
  deleteAsset: {},
  users: {
    isFetching: false,
    data: [],
    allUsers: [],
    headers: [],
    error: null,
    page: 1,
    userExistsIsFetching: false,
    userExists: "",
    userExistsProfile: "",
    userExistsWorkclientAlreadyDone: "",
    userExistsError: ""
  },
  invitation: {
    isFetching: false,
    accessToken: null,
    validate: false,
    user: null,
    error: null
  },
  permission: {
    show: false,
    item: {},
    openDetail: "HIDE",
    isFetchingObjectGroups: false
  },
  group: {
    byClientData: [],
    byClientUserData: [],
    matrix: [],
    newMatrix: [],
    hideButton: false,
    defaultPermissions: [],
    isFetchingDefaultPermissions: false
  },
  hoverVerticalView: null,
  notifications: {
    isFetching: false,
    toBeConfirmed: 0,
    userRequests: [],
    // jobs: [],
    showNotification: false,
    showModal: false,
    pid: null,
    socketStatus: false
  },
  jobs: {
    data: []
  },
  comments: {
    show: false,
    versionsShowCompare: false,
    versionsToCompare: [],
    allVersions: [],
    data: [],
    isCreating: false,
    isSearching: false,
    searchText: "",
    isCommentDetermined: false,
    isLoadingCommentText: false,
    isDeleteCommentDetermined: false,
    userDefaultComments: [],
    showCommentList: true,
    showBtnComment: false,
    itemSelected: {},
    isEmptyCompareData: true,
    showVersions: false,
    qtyVersions: "[..]",
    emoji: false,
    socketCommentScroll: null,
    isFetching: false,
    lastCommentsPage: 1,
    fromKeyCollection: null,
    focusDescription: false,
    adminUsersToComment: [],
    operatorsUsersToComment: [],
    isFetchingUsersToComment: false,
    isDoingACommentWithFile: false,
    isPdfTagActive: false,
    pdfCarouselIndex: 1,
    previousPdfCarouselIndex: {
      index: 1,
      isSettingPrevious: false
    },
    pdfTagClicked: { isClicked: false, newPdfCarouselIndex: null },
    imageTagClicked: {
      isClicked: false,
      index: null,
      pointX: null,
      pointY: null
    },
    videoTagClicked: { isClicked: false, time: null, version: null },
    audioTagClicked: { isClicked: false, time: null, version: null },
    isFetchingPages: false,
    userMentions: {
      mentions: [],
      isFetchingMetions: false,
      isSettingCommentAsSeen: false
    },
    isAudioTagActive: false,
    audioTime: "",
    isVideoTagActive: false,
    videoTime: "",
    isImageTagActive: false,
    imageTagXPer: 0,
    imageTagYPer: 0,
    imageTagWidth: 0,
    imageTagHeight: 0,
    imagePoint: 0
  },
  downloads: {
    data: [],
    data_chunks: {},
    isDownloadFolder: false,
    showProgressIndicator: false,
    cancelDownloadList: false,
    itemCancelFromDownload: null,
    defaultListDownloadHistory: "all",
    isFetchingHistory: false,
    isDownloading: false,
    mine: true,
    isPreparingDownload: false,
    showMultipleDownload: false,
    refreshDownloadHistory: false
  },
  middleView: {
    description: null,
    statusAsset: null,
    media: [],
    isFetching: false,
    error: null,
    wasDartUpdated: false,
    updatedAssetId: null
  },
  bunkeyHost: {
    asset: null,
    show: false
  },
  countryCodes: [],
  planServices: {
    data: [],
    isFetching: false,
    headers: [],
    error: null,
    fetchingUserServices: false,
    errorUserServices: null,
    userServices: [],
    linkGenerateLoading: false,
    linkGenerateError: false,
    linkGenerate: null,
    reducePlanLoading: false,
    reducePlanError: false
  },
  myPlanServices: {
    data: [],
    isFetching: false,
    headers: [],
    error: null
  },
  selectedFiles: {
    data: [],
    keyCollection: "",
    showModalMultiDownload: false,
    showModalMultiShare: false,
    showModalMultiDelete: false,
    showModalMultiMove: false
  },
  individualSelect: {
    selectedFile: null,
    action: "",
    keyCollection: "",
    section: ""
  },
  storage: {
    history: [],
    errorHistory: false,
    loadingHistory: true,
    assetsList: [],
    totalAssets: 0,
    errorAssetsList: false,
    loadingAssetsList: true
  },
  trash: {
    loadingTrashItems: false,
    errorTrashItems: true,
    trashItems: [],
    loadingClearAllTrash: false,
    errorClearAllTrash: true,
    loadingRestoreAssets: false,
    errorRestoreAssets: true,
    loadingDeleteAssets: false,
    errorDeleteAssets: true,
    loadingMoveAssets: false,
    errorMoveAssets: true,
    loadingDownloadAssets: false,
    errorDownloadAssets: true,
    loadingTrashUsageList: false,
    errorTrashUsageList: false,
    trashUsageList: [],
    totalAssets: 0
  },
  // Gestor de Derechos de Uso (DES-207 ampliado). Árbol por carpeta: se guarda
  // por nodo expandido, no como un árbol anidado, para poder actualizar un solo
  // nivel sin reconstruir todo el estado (mismo motivo que Breadcrumb.js).
  rights: {
    loadingSummary: false,
    errorSummary: false,
    summary: { unassigned: 0, valid: 0, expiring: 0, expired: 0, total: 0, outOfModule: 0, updatedAt: null },
    // { [folderId || 'root']: { loading, error, folders: [], files: [] } }
    nodes: {},
    loadingAssign: false,
    errorAssign: false,
    errorAssignCode: null,
    loadingExport: false,
    errorExport: false,
    loadingRevert: false,
    errorRevert: false,
    // Visor del asset: alimenta a CollectionMiddleView con el mismo contrato
    // que el resto de las colecciones (data + isSelected).
    viewer: {
      isFetching: false,
      error: false,
      data: [],
      folderselect: null
    },
    // Última operación por lote, para el UndoBanner. Vive sólo en memoria del
    // cliente que la disparó — no hay endpoint de "última operación de la
    // cuenta", así que no persiste entre sesiones.
    lastOperation: null,
    // Vista de lista (reporte plano). Vive aparte de `nodes` porque el árbol y
    // la lista se piden distinto y conviven: cambiar de vista no debería tirar
    // lo que la otra ya tenía cargado.
    list: {
      loading: false,
      error: false,
      rows: [],
      total: 0,
      page: 1,
      limit: 50,
      orderBy: "-createdAt",
    },
  },
  uploadFolder: {
    fileList: [],
    fileListToSave: [],
    fileIdsNotification: [],
    rootFolder: [],
    tags: [],
    dateFrom: undefined,
    dateFromFormatted: "",
    dateTo: undefined,
    dateToFormatted: "",
    usageRights: true,
    rightsStatus: "unassigned",
    rightsUiState: "unassigned",
    // Contrato de cesión del asistente de carpeta (punto 2 de Ricardo).
    licenseFile: null,
    usersEmails: [],
    tagsProtocol: "",
    route: "/",
    currentStep: 0,
    start: false,
    saveFolderStructureLoading: false,
    saveFolderStructureError: false,
    showUploadFolderModal: false,
    folderselect: "",
    folderList: []
  },
  tours: {
    tourDashboard: [],
    tourMenu: [],
    tourMenuFilters: [],
    tourMenuFiltersFinished: false,
    tourDashboardFilters: [],
    tourDashboardFiltersFinished: false,
    tourUsers: [],
    tourGroups: [],
    tourExplore: [],
    isFetching: false,
    headers: [],
    error: null,
    tourMenuOnlyView: false
  }
};
